import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import NProgress from 'nprogress/nprogress'
import routes from './routes'

Vue.use(VueRouter)
NProgress.configure({ showSpinner: false })

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/dashboard2/',
  scrollBehavior: (to, from, savedPosition) => savedPosition || { x: 0, y: 0 }
})

// Set page meta
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  document.querySelector('meta[name=description]').content = to.meta.description

  next()
})

// Trigger the Progress Bar
router.beforeResolve((routeTo, routeFrom, next) => {
  if (routeFrom.name) NProgress.start()
  next()
})
router.afterEach((routeTo, routeFrom) => NProgress.done())

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-11651599-1',
  router,
  autoTracking: {
    page: process.env.NODE_ENV !== 'development',
    pageviewOnLoad: false
  },
  ignoreRoutes: ['/404']
})

export default router
